import React from 'react';

interface FooterProps {
  userCourses?: string[];
}

const Footer: React.FC<FooterProps> = ({ userCourses = [] }) => {
  return (
    <footer style={{ 
      marginTop: '80px',
      background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.03"%3E%3Ccircle cx="30" cy="30" r="1"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
        opacity: 0.5
      }} />
      
      <div style={{ position: 'relative', zIndex: 2 }}>
        {/* Main Footer Content */}
        <div style={{ 
          maxWidth: '1400px',
          margin: '0 auto',
          padding: 'clamp(40px, 8vw, 80px) clamp(16px, 4vw, 20px) clamp(20px, 4vw, 40px)'
        }}>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(clamp(250px, 40vw, 320px), 1fr))', 
            gap: 'clamp(32px, 6vw, 48px)',
            marginBottom: 'clamp(32px, 6vw, 48px)'
          }}>
            {/* Brand Section */}
            <div style={{ maxWidth: '320px' }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'clamp(8px, 2vw, 12px)',
                marginBottom: 'clamp(16px, 3vw, 20px)'
              }}>
                <div style={{
                  width: 'clamp(40px, 8vw, 48px)',
                  height: 'clamp(40px, 8vw, 48px)',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 'clamp(16px, 3vw, 20px)',
                  fontWeight: '700',
                  color: 'white'
                }}>
                  S
                </div>
                <div>
                  <h3 style={{ 
                    margin: '0 0 4px 0', 
                    fontSize: 'clamp(18px, 4vw, 24px)', 
                    fontWeight: '700',
                    color: 'white',
                    letterSpacing: '-0.5px'
                  }}>
                    SDETPRO
                  </h3>
                  <p style={{ 
                    margin: 0, 
                    color: '#94a3b8', 
                    fontSize: 'clamp(12px, 2.5vw, 14px)',
                    fontWeight: '500'
                  }}>
                    Professional Test Automation Training
                  </p>
                </div>
              </div>
              <p style={{ 
                margin: '0 0 clamp(20px, 4vw, 24px) 0', 
                color: '#cbd5e1', 
                fontSize: 'clamp(13px, 2.5vw, 15px)',
                lineHeight: '1.6'
              }}>
                Master the art of test automation with industry-leading courses designed by experts. 
                Transform your career with hands-on training and real-world projects.
              </p>
            </div>

            {/* Social Links Section */}
            <div>
              <h4 style={{ 
                margin: '0 0 clamp(16px, 3vw, 20px) 0', 
                fontSize: 'clamp(16px, 3vw, 18px)', 
                fontWeight: '600',
                color: 'white'
              }}>
                Connect With Us
              </h4>
              <p style={{ 
                margin: '0 0 clamp(20px, 4vw, 24px) 0', 
                color: '#cbd5e1', 
                fontSize: 'clamp(13px, 2.5vw, 15px)',
                lineHeight: '1.6'
              }}>
                Join our community and stay updated with the latest courses and training opportunities.
              </p>
              
              {/* Social Links */}
              <div style={{ 
                display: 'flex', 
                gap: 'clamp(12px, 3vw, 16px)',
                flexWrap: 'wrap'
              }}>
                <a 
                  href="https://www.facebook.com/groups/sdetpro" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'clamp(44px, 8vw, 52px)',
                    height: 'clamp(44px, 8vw, 52px)',
                    backgroundColor: '#1877f2',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '12px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 12px rgba(24, 119, 242, 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#166fe5';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(24, 119, 242, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#1877f2';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(24, 119, 242, 0.3)';
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                
                <a 
                  href="https://www.youtube.com/c/SDETPRO/playlists" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'clamp(44px, 8vw, 52px)',
                    height: 'clamp(44px, 8vw, 52px)',
                    backgroundColor: '#ff0000',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '12px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 12px rgba(255, 0, 0, 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#e60000';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(255, 0, 0, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#ff0000';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 0, 0, 0.3)';
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                </a>
                
                <a 
                  href="https://www.linkedin.com/in/tu-huynh-van/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'clamp(44px, 8vw, 52px)',
                    height: 'clamp(44px, 8vw, 52px)',
                    backgroundColor: '#0077b5',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '12px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 12px rgba(0, 119, 181, 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#005885';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 119, 181, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#0077b5';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 119, 181, 0.3)';
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Instructor Section */}
            <div>
              <h4 style={{ 
                margin: '0 0 clamp(16px, 3vw, 20px) 0', 
                fontSize: 'clamp(16px, 3vw, 18px)', 
                fontWeight: '600',
                color: 'white'
              }}>
                Meet the Instructor
              </h4>
              <div style={{
                backgroundColor: 'rgba(255,255,255,0.05)',
                padding: 'clamp(16px, 3vw, 20px)',
                borderRadius: '12px',
                border: '1px solid rgba(255,255,255,0.1)'
              }}>
                <div style={{ fontSize: 'clamp(12px, 2.5vw, 14px)', color: '#94a3b8', marginBottom: 'clamp(8px, 2vw, 12px)', fontWeight: '500' }}>
                  👨‍🏫 Expert Instructor
                </div>
                <a 
                  href="https://www.linkedin.com/in/tu-huynh-van/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    color: '#cbd5e1',
                    textDecoration: 'none',
                    fontSize: 'clamp(14px, 3vw, 16px)',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: 'clamp(6px, 1.5vw, 8px)',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#667eea'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#cbd5e1'}
                >
                  Tu Huynh - Principal SDET
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{ opacity: 0.7 }}>
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <div style={{ fontSize: 'clamp(12px, 2.5vw, 14px)', color: '#94a3b8', marginBottom: 'clamp(6px, 1.5vw, 8px)' }}>
                  14 years experience • ISTQB Certified
                </div>
                <div style={{ fontSize: 'clamp(12px, 2.5vw, 14px)', color: '#94a3b8', marginBottom: 'clamp(8px, 2vw, 12px)' }}>
                  Master of Computer Science
                </div>
                <div style={{ fontSize: 'clamp(11px, 2vw, 12px)', color: '#64748b' }}>
                  Click name to view LinkedIn profile
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div style={{ 
            paddingTop: 'clamp(24px, 5vw, 32px)', 
            borderTop: '1px solid rgba(255,255,255,0.1)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 'clamp(12px, 3vw, 16px)',
            textAlign: 'center'
          }}>
            <p style={{ 
              margin: 0, 
              color: '#94a3b8', 
              fontSize: 'clamp(12px, 2.5vw, 14px)',
              fontWeight: '500',
              flex: '1',
              minWidth: '250px'
            }}>
              © {new Date().getFullYear()} SDETPRO. All rights reserved. | Professional Test Automation Training
            </p>
            <div style={{ display: 'flex', gap: 'clamp(16px, 4vw, 24px)', alignItems: 'center' }}>
              <span style={{ fontSize: 'clamp(10px, 2vw, 12px)', color: '#64748b' }}>
                Made with ❤️ for the testing community
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
